import { getVar } from "config";

const searchYoutubeVideo = async (videoId: string) => {
  const url = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${getVar(
    "REACT_APP_FIREBASE_API_KEY",
  )}`;

  try {
    const response = await fetch(url);

    if (response.ok) {
      const youtubeVideoData = await response.json();

      return youtubeVideoData?.items[0];
    }
    throw new Error(
      `[searchYoutubeVideo] Response: ${response.status} text: ${response.statusText}`,
    );
  } catch (err) {
    throw new Error(
      "[searchYoutubeVideo] unable to fetch youtube video data. Most likely a network failure",
    );
  }
};

export default searchYoutubeVideo;
